export const TRIGGER_WEBLAB_ASSIGNMENT = 'TRIGGER_WEBLAB_ASSIGNMENT';
export const SYNC_WEBLAB_TO_HYDRA = 'SYNC_WEBLAB_TO_HYDRA';
